import React from 'react';
import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'



function NavComponent() {

    const redirigirContacto = () => {
        window.open("https://www.grupobrame.com/contactus", "_blank", "noopener,noreferrer");
    };


    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    return (
        <header className="bg-gray-100">
            <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
                <div className="flex items-center gap-x-12">
                    <a href="https://www.grupobrame.com/" target="_blank" className="-m-1.5 p-1.5">
                        <span className="sr-only">Your Company</span>
                        <img src={require('../img/logo-brame.png')} alt="Grupo Brame Logo" className="logo h-8 w-auto"/>
                    </a>
                </div>
                <div className="lg:flex">
                    <a href="mailto:mejora.inovacion@grupobrame.com">
                        <button className="contact-button">Contáctanos</button>
                    </a>

                </div>
            </nav>
        </header>
    );
}

export default NavComponent;